import { Button, ButtonProps } from '@chakra-ui/react'
import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Icon } from '../Icon'

export interface IBackLinkProps extends Omit<ButtonProps, 'children' | 'leftIcon'> {
  /** Rota de destino. Sempre um link de verdade — dá clique do meio, "abrir em nova aba" e status bar. */
  to: string
  /** Texto do link. Padrão `Voltar`; diga para onde quando a origem não for óbvia na tela. */
  children?: ReactNode
}

/**
 * Link de volta no topo de uma página de detalhe.
 *
 * Eram **nove sites em três implementações**. A maior repetia o mesmo bloco de seis props em
 * cinco páginas (`ContestDetailPage`, `EventDetailPage`, `EventAdminPage`, `EventOrdersPage`,
 * `EventTransactionsPage`); `SupportViewPage` e `FinancialIndicatorsPage` tinham um botão
 * fantasma sem a cor cinza; e as duas páginas do AbraMídia tinham um `<Text>` magenta dentro de
 * um `<Link>` — mesma função, terceira aparência.
 *
 * As sete primeiras chamavam `navigate()` num `onClick`, então o link não era um link: não
 * abria em nova aba, não aparecia na barra de status e não respondia ao clique do meio. Aqui é
 * um `<Link>` do react-router, como o `to` do `ActionButton` e do `ActionFab` já fazia.
 */
export default function BackLink({ to, children = 'Voltar', ...rest }: IBackLinkProps) {
  return (
    <Button
      as={Link}
      to={to}
      variant="ghost"
      size="sm"
      pl={0}
      fontWeight="normal"
      color="gray.500"
      leftIcon={<Icon name="lni lni-arrow-left" />}
      // Sem padding à esquerda o fundo do `ghost` no hover ficaria deslocado do texto, então o
      // estado de hover é só a cor — que é o que a implementação de cinco páginas já fazia.
      _hover={{ color: 'gray.700', bg: 'transparent', textDecoration: 'none' }}
      _active={{ bg: 'transparent' }}
      {...rest}
    >
      {children}
    </Button>
  )
}
